import { tokens } from "@core/theme/tokens";
import { RedemptionsPanel } from "./RedemptionsPanel";

// SPEC-220 §3/ANNEX-010 §2.2: entrada propia bajo Gestión de miembros,
// `/portal/redemptions` (screens.json `portal.redemptions`). Sin filtro de
// miembro fijo: acá se puede elegir cualquiera (a diferencia del panel
// embebido en la ficha, `RedemptionsPanel` usado directo desde
// `MembersScreen.tsx`).
export function RedemptionsScreen() {
  return (
    <div>
      <header style={{ marginBottom: 18 }}>
        <h1
          className="display"
          style={{ fontSize: 26, margin: 0, color: tokens.text.primary }}
        >
          Consumos
        </h1>
      </header>
      <RedemptionsPanel />
    </div>
  );
}
